import api from 'Application/api/api';

const getTemplateGroups = (cancelToken = null) =>
    api.get('project-manager/template-groups', {
        params: {},
        cancelToken,
    });

export default getTemplateGroups;
